import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationDrawer'),_c(VCol,{staticClass:"wrap"},[_c('Card'),_c('div',{staticClass:"important-message"},[_c(VIcon,{staticClass:"ml-2 mr-2"},[_vm._v("mdi-information-outline")]),_vm._v("\n\n      Due to price hike from broadcasters, there will be some changes in\n      packages from 01 April, 2025. Discounts will be given accordingly.\n    ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }